import { useAutoAnimate } from "@formkit/auto-animate/react"

interface InputProps {
	props?: any
	className?: string | null
	label?: string | null
	errMsg?: string
	onClick?: any
	showLeftCount?: boolean
	hasError?: boolean
	suffix?: string
}

const ElemInput: React.FC<InputProps> = ({ className, props, label, onClick, errMsg, showLeftCount, hasError, suffix }) => {
	const [animationRef] = useAutoAnimate<HTMLDivElement>()
	return (
		<label className={"relative block " + (className || "")}>
			<input
				className={
					(props.type === "date" ? "" : " peer ") +
					"pt-4 w-full rounded-[9px] px-4 text-lg font-Manrope text-black h-[72px] leading-[72px] placeholder-transparent outline-0 appearance-none bg-white " +
					(hasError ? "  js-formerror " : "") +
					(props.type === "date" ? " uppercase" : "")
				}
				onClick={onClick}
				{...props}
			/>
			<span
				className={
					(props.type === "date" ? "-translate-y-4 " : "  peer-focus:-translate-y-4 transition ") +
					(!!props.value ? "-translate-y-4" : "") +
					" absolute left-0 top-0 font-Museo text-lg px-4 h-[72px] leading-[72px] pointer-events-none " +
					(hasError ? "  text-red " : " text-brown ")
				}
			>
				{label}
			</span>
			{suffix && <div className="absolute top-6 right-3 text-brown">{suffix}</div>}
			{showLeftCount && props.maxLength && (
				<div className="absolute top-6 right-3 text-brown">
					{props.value.length}/{props.maxLength}
				</div>
			)}
			<div ref={animationRef}>{hasError && <div className="formErrorMsg ">{errMsg}</div>}</div>
		</label>
	)
}

export default ElemInput

// https://play.tailwindcss.com/tKldzVn3U1
